<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" *ngIf="user.role === 'ROLE_ADMIN'"><a routerLink="/admin/adminDashboard/">Home</a>
      </li>
      <li class="breadcrumb-item" *ngIf="user.role === 'ACCOUNT_OWNER' || user.role === 'DEMO_ACCOUNT'"><a
        routerLink="/admin/dashboard/">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">Invoices</li>
    </ol>
  </nav>
  <div class="invalid-feedback d-block shift-invalid-text w-75" [hidden]="!errorMessage">{{errorMessage}}</div>
  <div class="row align-items-center">
    <div class="col-8">
      <ul class="list-inline tab-list deskContent">
        <li class="list-inline-item"><a (click)="populateTabData('all','ALL');resetCheckedList(); tabChange();"
                                        [ngClass]="{'active': tabClicked === 'all'}">All</a></li>
        <li class="list-inline-item"><a (click)="populateTabData('unPaid','UNPAID');resetCheckedList(); tabChange();"
                                        [ngClass]="{'active': tabClicked === 'unPaid'}">New</a></li>
        <li class="list-inline-item"><a (click)="populateTabData('overDue','overDue');resetCheckedList(); tabChange();"
                                        [ngClass]="{'active': tabClicked === 'overDue'}">Overdue</a></li>
        <li class="list-inline-item"><a
          (click)="populateTabData('inProcess','IN_PROCESS');resetCheckedList(); tabChange();"
          [ngClass]="{'active': tabClicked === 'inProcess'}">Paid</a></li>
        <li class="list-inline-item"><a (click)="populateTabData('paid','PAID');resetCheckedList(); tabChange();"
                                        [ngClass]="{'active': tabClicked === 'paid'}">Completed</a></li>


        <!--        <button  type="button" class="btn btn-outline-primary ml-2 float-right">Action</button>-->
      </ul>
      <select class="form-control MobileContent" id="use2r" [(ngModel)]="userDrop2"
              [ngModelOptions]="{standalone: true}" (change)="populate(userDrop2)" style="width: 140px;"
              data-value="All" required>
        <option value="ALL">All</option>
        <option value="UNPAID">New</option>
        <option value="overDue">Overdue</option>
        <option value="IN_PROCESS">Paid</option>
        <option value="PAID">Completed</option>
      </select>
    </div>
    <div class="col-4 mt-md-0 text-right float-right">
      <a routerLink="/admin/createInvoice" class="btn btn-outline-primary btn-sm ml-2"
         [hidden]="user.role !== 'ROLE_ADMIN'" *ngIf="user.role !== 'ROLE_USER'">
        <svg class="mr-2" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
          <path id="Icon_awesome-plus-circle" data-name="Icon awesome-plus-circle"
                d="M8.563.563a8,8,0,1,0,8,8A8,8,0,0,0,8.563.563Zm4.645,8.9a.388.388,0,0,1-.387.387H9.853v2.968a.388.388,0,0,1-.387.387H7.659a.388.388,0,0,1-.387-.387V9.853H4.3a.388.388,0,0,1-.387-.387V7.659A.388.388,0,0,1,4.3,7.272H7.272V4.3a.388.388,0,0,1,.387-.387H9.466a.388.388,0,0,1,.387.387V7.272h2.968a.388.388,0,0,1,.387.387Z"
                transform="translate(-0.563 -0.563)" fill="#fff"/>
        </svg>
        Create
      </a>
      <button data-toggle="dropdown" *ngIf=" (checkedList?.length) && user.role !== 'ROLE_USER' && tabClicked !== 'all'"
              aria-haspopup="true" aria-expanded="false"
              class="btn ml-2 btn-outline-primary  btn-sm dropdown-toggle  d-none-mobile">
        Actions
      </button>
      <div class="dropdown-menu dropdown-menu2  dropdown-menu-right" *ngIf="(checkedList?.length)">
        <a (click)="payInvoice(invoice)" class="dropdown-item file btn shift-import"
           disabled="invoice.length > 1">Pay</a>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="inner-box d-none d-sm-block" [ngClass]="{'show-pagination':(!totalRecords || totalRecords<20)}">
        <table class="table" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
          <thead>
          <tr>
            <th *ngIf="user.role !== 'ROLE_USER'" [hidden]="tabClicked === 'all'">
              <!-- <div class="form-checkbox">
                   <input type="checkbox" id="all_items" [(ngModel)]="masterSelected" name="list_name" value="m1" (change)="checkUncheckAll()" />
                   <label for="all_items"></label>
               </div>-->
            </th>
            <th style="width: auto!important;">Invoice Number</th>
            <th style="width: auto!important;">Invoice Type</th>
            <th style="width: auto!important;">Invoice Date</th>
            <th style="width: auto!important;">Invoice Amount</th>
            <th style="width: auto!important;">Status</th>
            <th style="width: auto!important;"></th>
          </tr>
          </thead>
          <tbody class="table-body-custom">
          <tr *ngFor="let i of invoice">
            <td *ngIf="user.role !== 'ROLE_USER'" [hidden]="tabClicked === 'all'">
              <div class="form-checkbox">
                <input type="checkbox" id="{{i.id}}" [(ngModel)]="i.isSelected" name="list_name"
                       (change)="selectInvoice(i)">
                <label for="{{i.id}}"></label></div>
            </td>
            <td><a class="ml-2" id="modalActivateAO" (click)="showInvoiceById(i)" data-toggle="modal"
                   href="#exampleModalPreview">{{i.invoiceNum}}</a></td>
            <td>{{(i.invoiceType == 'WORK_ORDER' ? 'Work Order' : (i.invoiceType == 'SHIP_INVOICE' ? 'Ship Invoice' :
              (i.invoiceType == 'INVOICE_TYPE' ? 'Invoice Type' : (i.invoiceType == 'FULFILLMENT' ? 'Fulfillment' :
                i.invoiceType))))| titlecase}}
            </td>
            <td>{{i.invoiceDate}}</td>
            <td>{{i.totalAmount}}</td>
            <td>{{(i.paymentStatus == 'PAID' ? 'Paid' : (i.paymentStatus == 'UNPAID' ? 'Unpaid' : (i.paymentStatus ==
            'IN_PROCESS' ? 'Submitted' : "")))}}
            </td>
            <!--              <td><a [hidden]="tabClicked !== 'unPaid'" routerLink="/admin/paymentProcessing/{{i.id}}"
    class="btn btn-orange">Pay</a></td>-->
            <td><a href="{{i.invoiceFileUrl}}" target="_blank">
              <svg class="svg-icon" viewBox="0 0 20 20">
                <path fill="none"
                      d="M15.608,6.262h-2.338v0.935h2.338c0.516,0,0.934,0.418,0.934,0.935v8.879c0,0.517-0.418,0.935-0.934,0.935H4.392c-0.516,0-0.935-0.418-0.935-0.935V8.131c0-0.516,0.419-0.935,0.935-0.935h2.336V6.262H4.392c-1.032,0-1.869,0.837-1.869,1.869v8.879c0,1.031,0.837,1.869,1.869,1.869h11.216c1.031,0,1.869-0.838,1.869-1.869V8.131C17.478,7.099,16.64,6.262,15.608,6.262z M9.513,11.973c0.017,0.082,0.047,0.162,0.109,0.226c0.104,0.106,0.243,0.143,0.378,0.126c0.135,0.017,0.274-0.02,0.377-0.126c0.064-0.065,0.097-0.147,0.115-0.231l1.708-1.751c0.178-0.183,0.178-0.479,0-0.662c-0.178-0.182-0.467-0.182-0.645,0l-1.101,1.129V1.588c0-0.258-0.204-0.467-0.456-0.467c-0.252,0-0.456,0.209-0.456,0.467v9.094L8.443,9.553c-0.178-0.182-0.467-0.182-0.645,0c-0.178,0.184-0.178,0.479,0,0.662L9.513,11.973z"></path>
              </svg>
            </a></td>
          </tr>
          </tbody>
          <tfoot>
          <tr *ngIf="invoice?.length===0|| !invoice?.length">
            <td colspan="6" class="text-center">No matching records found</td>
          </tr>
          </tfoot>
        </table>
      </div>
      <div class="inner-box d-block d-sm-none ">
        <table class="table tablesaw  tablesaw-stack" data-tablesaw-mode="stack">
          <thead>
          <tr>
            <th>Invoice Number</th>
            <th>Invoice Type</th>
            <th>Invoice Date</th>
            <th>Invoice Amount</th>
            <th>Status</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let i of invoice">
            <td><b class=" tablesaw-cell-label">Invoice Number</b>
              <span class="tablesaw-cell-content">
                <a class="ml-2" id="modalActivateAOMobile" (click)="showInvoiceById(i)" data-toggle="modal"
                   href="#exampleModalPreview">{{i.invoiceNum}}</a></span></td>
            <td><b class=" tablesaw-cell-label">Invoice Type</b>
              <span
                class="tablesaw-cell-content">{{(i.invoiceType == 'WORK_ORDER' ? 'Work Order' : (i.invoiceType == 'SHIP_INVOICE' ? 'Ship Invoice' : (i.invoiceType == 'FULFILLMENT' ? 'Fulfillment' : i.invoiceType)))}}</span>
            </td>
            <td><b class=" tablesaw-cell-label">Invoice Date</b>
              <span class="tablesaw-cell-content">{{i.invoiceDate}}</span></td>
            <td><b class=" tablesaw-cell-label">Invoice Amount</b>
              <span class="tablesaw-cell-content">{{i.totalAmount}}</span></td>
            <td><b class=" tablesaw-cell-label">Status</b>
              <span
                class="tablesaw-cell-content">{{(i.paymentStatus == 'PAID' ? 'Paid' : (i.paymentStatus == 'UNPAID' ? 'Unpaid' : (i.paymentStatus == 'IN_PROCESS' ? 'Submitted' : "")))}}
              </span></td>
            <td>
              <a href="{{i.invoiceFileUrl}}" target="_blank">
                <svg class="svg-icon" viewBox="0 0 20 20">
                  <path fill="none"
                        d="M15.608,6.262h-2.338v0.935h2.338c0.516,0,0.934,0.418,0.934,0.935v8.879c0,0.517-0.418,0.935-0.934,0.935H4.392c-0.516,0-0.935-0.418-0.935-0.935V8.131c0-0.516,0.419-0.935,0.935-0.935h2.336V6.262H4.392c-1.032,0-1.869,0.837-1.869,1.869v8.879c0,1.031,0.837,1.869,1.869,1.869h11.216c1.031,0,1.869-0.838,1.869-1.869V8.131C17.478,7.099,16.64,6.262,15.608,6.262z M9.513,11.973c0.017,0.082,0.047,0.162,0.109,0.226c0.104,0.106,0.243,0.143,0.378,0.126c0.135,0.017,0.274-0.02,0.377-0.126c0.064-0.065,0.097-0.147,0.115-0.231l1.708-1.751c0.178-0.183,0.178-0.479,0-0.662c-0.178-0.182-0.467-0.182-0.645,0l-1.101,1.129V1.588c0-0.258-0.204-0.467-0.456-0.467c-0.252,0-0.456,0.209-0.456,0.467v9.094L8.443,9.553c-0.178-0.182-0.467-0.182-0.645,0c-0.178,0.184-0.178,0.479,0,0.662L9.513,11.973z"></path>
                </svg>
              </a></td>
            <!--              <td><a [hidden]="tabClicked !== 'unPaid'" routerLink="/admin/paymentProcessing/{{i.id}}"
                class="btn btn-orange">Pay</a></td>-->
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</section>

<!-- Modal -->
<div class="modal fade right invoice" id="exampleModalPreview" tabindex="-1" role="dialog"
     aria-labelledby="exampleModalPreviewLabel" aria-hidden="true">
  <div class="modal-dialog snk-modal-dialog modal-fluid modal-dialog-scrollable" role="document">
    <div class="snk-modal-content modal-content">
      <div class="snk-modal-header modal-header text-center">
        <h5 class="modal-title w-100" id="exampleModalPreviewLabel">Invoice</h5>
        <button type="button" class="close " data-dismiss="modal" aria-label="Close">
          <span style="font-size: 1.3em;" aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form>
          <div class="row mt-3">
            <div class="col">
              <div class="inner-box" style="overflow:overlay;">
                <div class="row">
                  <div class="col">
                    <div class="row">
                      <div class="col">
                        <div class="row mt-3">
                          <div class="col-md-6">
                            <address class="ml-2">
                              <strong>To:</strong><br>
                              <label><b>Company Name :</b><span
                                class="ml-1">{{invoiceData.companyName | titlecase}}</span></label><br>
                              <label><b>Contact Person :</b><span
                                class="ml-1">{{invoiceData.ownerName | titlecase}}</span></label><br>
                              <label><b>Phone Number :</b><span class="ml-1">{{invoiceData.mobile}}</span></label><br>
                              <label><b>Email :</b><span class="ml-1">{{invoiceData.email}}</span></label><br>
                              <label><b>Address :</b><span class="ml-1">{{invoiceData.addressText}}</span></label>
                            </address>
                          </div>
                          <div class="col-md-6">
                            <address>
                              <br>
                              <label><b>Invoice Number :</b><span class="ml-1">{{invoiceData.invoiceNum}}</span></label><br>
                              <label><b>Invoice Date :</b><span
                                class="ml-1">{{invoiceData.invoiceDate}}</span></label><br>
                              <label><b>Invoice Type :</b><span
                                class="ml-1">{{(invoiceData.invoiceType == 'WORK_ORDER' ? 'Work Order' :
                                (invoiceData.invoiceType == 'SHIP_INVOICE' ? 'Ship Invoice' : (invoiceData.invoiceType == 'FULFILLMENT' ? 'Fulfillment' : "")))}}</span></label><br>
                              <label><b>Invoice Status :</b><span
                                class="ml-1">{{(invoiceData.paymentStatus == 'UNPAID' ? 'UnPaid' :
                                (invoiceData.paymentStatus == 'PAID' ? 'Paid' : (invoiceData.paymentStatus == 'IN_PROCESS' ? 'In Process' : "")))}}</span></label><br>
                            </address>
                          </div>
                        </div>
                        <div class="row mt-3">
                          <div class="col">
                            <table class="table" style="white-space:nowrap">
                              <thead>
                              <tr>
                                <th>Line Number</th>
                                <th>Description</th>
                                <th>Amount</th>
                                <th>Reference Type</th>
                                <th>Order Number</th>
                              </tr>
                              </thead>
                              <tbody>
                              <tr *ngFor="let inv of invoiceLinesVal">
                                <td>{{inv.invoiceLineNum}}</td>
                                <td>{{(inv.itemCode == 'KITTING' ? 'Kitting' : (inv.itemCode == 'LOGISTICS' ?
                                  'Logistics' : (inv.itemCode == 'SHIP_INVOICE' ? 'Ship Invoice' : (inv.itemCode ==
                                  'FULFILLMENT' ? 'Fulfillment' : ""))))}}
                                </td>
                                <td>{{inv.invoiceAmount | number: '1.2-2'}}</td>
                                <td>{{(inv.invoiceType == 'WORK_ORDER' ? 'Work Order' : (inv.refType == 'FULFILLMENT' ?
                                  'Fulfillment' : (inv.refType == 'IN_PROCESS' ? 'In Process' : "")))}}
                                </td>
                                <td>{{inv.refNumber}}</td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-6">
                          </div>
                          <div class="col-6 deskContent" style="text-align:right;">
                            <label><b>Sub Total :</b><span
                              class="ml-1"> {{invoiceData.totalAmount | number: '1.2-2'}}</span></label><br>
                            <label *ngIf="invoiceData.discountPrice > 0"><b>Discount :</b><span
                              class="ml-1"> {{invoiceData.discountPrice | number: '1.2-2'}}</span></label><br>
                            <label><b>IGST (18%) :</b><span
                              class="ml-1"> {{invoiceData.taxableAmount | number: '1.2-2'}}</span></label><br>
                            <label><b>CGST (9%) :</b><span
                              class="ml-1"> {{invoiceData.taxableAmount1 | number: '1.2-2'}}</span></label><br>
                            <label><b>SGST (9%) :</b><span
                              class="ml-1"> {{invoiceData.taxableAmount2 | number: '1.2-2'}}</span></label><br>
                            <label><b>Total Amount :</b><span
                              class="ml-1"> {{invoiceData.calculatedTaxAmount  | number: '1.2-2' }}</span></label><br>
                            <label class="word"><b>In Words :</b><span class="ml-1">{{invoiceData.priceInWords}}
                              </span></label>
                          </div>
                          <div class="col-md-6 MobileContent" style="text-align:right;margin-left:165px;">
                            <label><b>Sub Total :</b><span
                              class="ml-1"> {{invoiceData.totalAmount | number: '1.2-2'}}</span></label><br>
                            <div *ngIf="invoiceData.discountPrice > 0">
                              <label><b>Discount :</b><span
                                class="ml-1"> {{invoiceData.discountPrice | number: '1.2-2'}}</span></label><br>
                            </div>
                            <label><b>IGST (18%) :</b><span
                              class="ml-1"> {{invoiceData.taxableAmount | number: '1.2-2'}}</span></label><br>
                            <label><b>CGST (9%) :</b><span
                              class="ml-1"> {{invoiceData.taxableAmount1 | number: '1.2-2'}}</span></label><br>
                            <label><b>SGST (9%) :</b><span
                              class="ml-1"> {{invoiceData.taxableAmount2 | number: '1.2-2'}}</span></label><br>
                            <label><b>Total Amount :</b><span
                              class="ml-1"> {{invoiceData.calculatedTaxAmount  | number: '1.2-2' }}</span></label><br>
                            <label class="word"><b>In Words :</b><span class="ml-1">{{invoiceData.priceInWords}}
                              </span></label>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-6"></div>
            <div class="col-md-6 text-right">
              <button class="btn btn-cancel" type="button" data-dismiss="modal" aria-label="Close">Close</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<!-- Modal -->
